"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmailCommunicationPreferences = getEmailCommunicationPreferences;
exports.getIsConditionsEnabled = getIsConditionsEnabled;
exports.getIsMentalHealthScreeningEnabled = getIsMentalHealthScreeningEnabled;
exports.createGlobalClassifierIdentifiers = createGlobalClassifierIdentifiers;
exports.getShouldShowResultsCrisisDialog = getShouldShowResultsCrisisDialog;
exports.getShouldReplaceSearchHelplineWithCrisis = getShouldReplaceSearchHelplineWithCrisis;
function getEmailCommunicationPreferences(circle) {
    var _a, _b, _c;
    return (_c = (_b = (_a = circle === null || circle === void 0 ? void 0 : circle.globalClassifier) === null || _a === void 0 ? void 0 : _a.optIns) === null || _b === void 0 ? void 0 : _b.emailCommunication) === null || _c === void 0 ? void 0 : _c.type;
}
function getIsConditionsEnabled(circle) {
    var _a, _b, _c;
    return !!((_c = (_b = (_a = circle === null || circle === void 0 ? void 0 : circle.globalClassifier) === null || _a === void 0 ? void 0 : _a.conditions) === null || _b === void 0 ? void 0 : _b.selection) === null || _c === void 0 ? void 0 : _c.enabled);
}
function getIsMentalHealthScreeningEnabled(circle) {
    var _a, _b, _c;
    return !!((_c = (_b = (_a = circle === null || circle === void 0 ? void 0 : circle.globalClassifier) === null || _a === void 0 ? void 0 : _a.survey) === null || _b === void 0 ? void 0 : _b.mentalHealth) === null || _c === void 0 ? void 0 : _c.enabled);
}
// https://github.com/calm/evexia-vault-config/blob/master/files/staging/global_classifiers.yml
function createGlobalClassifierIdentifiers(circle) {
    var _a, _b;
    const splitBy_ = (_b = (_a = circle === null || circle === void 0 ? void 0 : circle.globalClassifier) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.split('_');
    const countryCodeClassifier = splitBy_ === null || splitBy_ === void 0 ? void 0 : splitBy_.shift();
    const otherClassifiers = (splitBy_ === null || splitBy_ === void 0 ? void 0 : splitBy_.join('_')) || undefined;
    return { countryCodeClassifier, otherClassifiers };
}
const countryCodesSupportingResultsCrisisDialog = ['us', 'um', 'pr', 'gb', 'ca'];
function getShouldShowResultsCrisisDialog(circle) {
    const countryCode = createGlobalClassifierIdentifiers(circle).countryCodeClassifier;
    return (!!countryCode &&
        countryCodesSupportingResultsCrisisDialog.includes(countryCode.toLowerCase()));
}
// We want to maintain a different list here to allow for future flexibility
// These arrays are technically not related
const replaceHelplineCountryCodesList = ['us', 'um', 'pr', 'gb', 'ca'];
function getShouldReplaceSearchHelplineWithCrisis(circle) {
    const countryCode = createGlobalClassifierIdentifiers(circle).countryCodeClassifier;
    return (!!countryCode &&
        replaceHelplineCountryCodesList.includes(countryCode.toLowerCase()));
}
//# sourceMappingURL=index.js.map